import * as React from "react";
import { cn } from "@finster/ui";
import { ScrollText } from "lucide-react";
import type { SelectedSkillReference } from "../types";

export interface SkillActiveActivityProps {
  skill: SelectedSkillReference;
  className?: string;
}

export const SkillActiveActivity: React.FC<SkillActiveActivityProps> = ({ skill, className }) => (
  <div
    role="status"
    aria-label={`Read skill · /${skill.slug}`}
    className={cn(
      "inline-flex min-h-6 max-w-full items-center gap-1.5 rounded-full border border-border bg-background-tertiary px-2 py-0.5 text-xs text-foreground",
      className
    )}
  >
    <ScrollText className="size-4 shrink-0" aria-hidden />
    <span className="truncate">Read skill · /{skill.slug}</span>
  </div>
);
